module.exports = __webpack_public_path__ + "static/media/digging.2cf9255a.svg";